// Full fixed version of the Works component
import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown ,Popover} from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import swal from "sweetalert2";
import moment from 'moment';
import axios from 'axios';
import ViewItem from '../../../modal/Production_Management/Manage_Quality_Analysis/View';
import EditItem from '../../../modal/Production_Management/Manage_Quality_Analysis/Edit';
import AddWastage from '../../../modal/Production_Management/Manage_Quality_Analysis/AddWastage';
import Rework from '../../../modal/Production_Management/Manage_Quality_Analysis/Rework';
import Edit from '../../../modal/subscriber/Edit';
import Verify_Checklist from '../../../modal/Production_Management/Manage_Works/Verify_Checklist';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import bgimage from '../../../../images/items/items.jpg';
import WorkChecklist from '../../../modal/Production_Management/Manage_Quality_Analysis/WorkChecklist'; 
import staff1 from '../../../../images/staff/member_2.png';
import staff2 from '../../../../images/staff/member_1.png';


const Works = () => { 
 
    const onInit = () => { 
    };
 

const getStatusLabel = (status) => {
  switch (parseInt(status)) {
    case 0: return "Work Not Started"; 
    case 1: return "Work Proces...";
    case 2: return "Work Done";
    case 3: return "Awaiting Appr...";
    case 4: return "Checking..";
    case 5: return "Approved";
    case 6: return "Rework";
    default: return "Unknown";
  }
};

const getBadgeVariant = (status) => {
  switch (parseInt(status)) {
    case 0: return "dark";
    case 1: return "secondary";
    case 2: return "success";
    case 3: return "warning";
    case 4: return "danger";
    case 5: return "primary";
    case 6: return "danger";
    default: return "dark";
  }
};

const getNextStatusOptions = (currentStatus) => {
  switch (parseInt(currentStatus)) {
    case 0: return [1]; // Work Not Started → Work Processing
    case 1: return [2]; // Work Processing → Work Done
    case 2: return [3]; // Work Done → Awaiting Approval
    default: return []; // 3+ → no change allowed
  }
};

const handleStatusChange = (sno, newStatus, itemName) => {
  swal.fire({
    html: `
      <div class="alert alert-success px-2 py-2" role="alert">
        Are you sure you want to change the status?
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
      <div class="row mb-2 text-center">
        <label class="text-black font-w300"><b>${itemName || '-'}</b></label>
      </div>
      <div class="text-center mt-4 mb-3">
        <label class="fw-bold text-dark fs-2">${getStatusLabel(newStatus)}</label>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Yes, Update',
    cancelButtonText: 'Cancel',
    reverseButtons: true,
    customClass: {
      cancelButton: 'btn btn-sm btn-secondary',
      confirmButton: 'btn btn-sm btn-success',
      htmlContainer: 'text-left'
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then((result) => {
    if (result.isConfirmed) {
      axios.post(`${baseURL}/work-assignment/${sno}`, {
        workassignment_status: newStatus
      }).then(res => {
        swal.fire('✅ Updated!', 'Status changed successfully.', 'success');
        fetchWork(); // Refresh
      }).catch(err => {
        swal.fire('❌ Error!', err.response?.data?.message || 'Failed to update status.', 'error');
        console.error(err);
      });
    }
  });
};

    const [selectedAssignment, setSelectedAssignment] = useState(null);
    const handleModalToggleCheckList = (assignment) => {
        setSelectedAssignment(assignment);
        setModalType("Verify_Checklist");
        setOpen(true);
    };
 

            const handleModalToggle_View = (assignment) => {
        setSelectedAssignment(assignment);
        setModalType("ViewQuality");
        setOpen(true);
    };


        const handleModalToggle_Work = (assignment) => {
        setSelectedAssignment(assignment);
        setModalType("WorkChecklist");
        setOpen(true);
    };
 
        const handleModalToggle_Edit = (assignment) => {
            setSelectedAssignment(assignment);
            setModalType("EditQuality");
            setOpen(true);
        };
      

        const handleModalToggle_AddWastage = (assignment) => {
    setSelectedAssignment(assignment);
    setModalType("AddWastage");
    setOpen(true);
};
 

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const tableRef = useRef(null);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(moment().startOf('isoWeek').toDate());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(moment().endOf('isoWeek').toDate());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const [assignments, setAssignments] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [TotalCount, setTotalCount] = useState('');

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];
    const [hasFetched, setHasFetched] = useState(false); 
   

        const fetchWork = (isFiltered = true) => {
        const params = {};

         if (isFiltered && date_fil_selt_value !== "all") {
            switch (date_fil_selt_value) {
                case "today":
                case "date":
                    params.filter = "date"; 
                    params.date = moment(today_fil_value.toDate?.() || today_fil_value).format("YYYY-MM-DD");

                    break;


        // if (date_fil_selt_value === "all") {
        //     params.filter = "all";
        // } else if (isFiltered) {
        //     switch (date_fil_selt_value) {
        //         case "today":
        //         case "date":
        //             params.filter = "date";
        //             params.date = moment(today_fil_value.toDate?.() || today_fil_value).format("YYYY-MM-DD");
        //             break;
                case "this_week":
                    params.filter = "week";
                    params.start_date = moment(week_stdt_fil_value.toDate?.() || week_stdt_fil_value).format("YYYY-MM-DD");
                    params.end_date = moment(week_eddt_fil_value.toDate?.() || week_eddt_fil_value).format("YYYY-MM-DD");
                    break;
                case "this_month":
                    const month = moment(month_fil_value.toDate?.() || month_fil_value).format("YYYY-MM");
                    params.filter = "month";
                    params.start_month = month;
                    params.end_month = month;
                    break;
                case "custom":
                    params.filter = "custom";
                    params.start_date = moment(custom_stdt_fil_value.toDate?.() || custom_stdt_fil_value).format("YYYY-MM-DD");
                    params.end_date = moment(custom_eddt_fil_value.toDate?.() || custom_eddt_fil_value).format("YYYY-MM-DD");
                    break;
                default:
                    break;
            }
        }

        axios.get(`${baseURL}/assignments`, { params })
            .then(res => {
                if (res.data?.data) {
                    setAssignments(res.data.data);
                    setTotalCount(res.data.count);
                    setHasFetched(true);
                    setTotalPages(Math.ceil(res.data.count / perPage));

                    setTimeout(() => {
                        if ($.fn.dataTable.isDataTable(tableRef.current)) {
                            $(tableRef.current).DataTable().destroy();
                        }
                        $(tableRef.current).DataTable({
                            dom: 'Bfrtip',
                            buttons: [
                                { extend: 'csv', className: 'buttons-csv d-none' },
                                { extend: 'excel', className: 'buttons-excel d-none' },
                                { extend: 'print', className: 'buttons-print d-none' }
                            ]
                        });
                    }, 100);
                }
            })
            .catch(err => {
                console.error("API Error: ", err);
                setHasFetched(true);
            });
    };

    const handleResetFilter = () => {
        setDateFilSeltValue("all");
        setTodayFilValue(new Date());
        setWeekSTDTFilValue(moment().startOf('isoWeek').toDate());
        setWeekEDDTFilValue(moment().endOf('isoWeek').toDate());
        setMonthFilValue(new Date());
        setCustomSTDTFilValue(new Date());
        setCustomEDDTFilValue(new Date());
        setPage(1);
        setFilterOpen(false);
        fetchWork(false);
    };

    const handleGoFilter = () => {
        setPage(1);
        setFilterOpen(false);
        const applyFilters = date_fil_selt_value !== "all";
        fetchWork(applyFilters);
    };

    const exportToCSV = () => {
        const csvRows = [];
        const headers = ['Item', 'Category / Sub Category', 'Product Category', 'Qty / Units', 'Assign Works', 'Status'];
        csvRows.push(headers.join(','));

        assignments.forEach(item => {
            const row = [
                item.item_info?.name,
                `${item.item_info?.category} / ${item.item_info?.sub_category}`,
                item.product_info?.product_name || '-',
                `${item.product_info?.quantity} ${item.product_info?.measurement_unit}`,
                item.stagging_with_staff?.map(staff => staff.staff_name).join(', '),
                'Work Not Started'
            ];
            csvRows.push(row.join(','));
        });

        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'work_assignments.csv');
    };

    const exportToExcel = () => {
        const data = assignments.map(item => ({
            'Item': item.item_info?.name,
            'Category / Sub Category': `${item.item_info?.category} / ${item.item_info?.sub_category}`,
            'Product Category': item.product_info?.product_name || '-',
            'Qty / Units': `${item.product_info?.quantity} ${item.product_info?.measurement_unit}`,
            'Assign Works': item.stagging_with_staff?.map(staff => staff.staff_name).join(', '),
            'Status': 'Work Not Started'
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Assignments');
        XLSX.writeFile(workbook, 'work_assignments.xlsx');
    };

  
    const printTable = () => {
    const printContent = document.getElementById('work_assignment_table')?.outerHTML || '<p>No Data</p>';
    const newWin = window.open('', '_blank');
    newWin.document.write('<html><head><title>Work Assignment Print</title>');
    newWin.document.write('<style>table { width: 100%; border-collapse: collapse; } td, th { padding: 6px; border: 1px solid #ccc; }</style>');
    newWin.document.write('</head><body>');
    newWin.document.write('<h2>Work Assignment</h2>');
    newWin.document.write(printContent);
    newWin.document.write('</body></html>');
    newWin.document.close();
    newWin.print();
};


    const handleExport = (type) => {
        switch (type) {
            case 'csv':
                exportToCSV();
                break;
            case 'excel':
                exportToExcel();
                break;
            case 'print':
                printTable();
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        fetchWork(false);
    }, []);


    
const [isVisible, setIsVisible] = useState({});

const toggleDiv = (index) => {
  setIsVisible((prev) => ({
    ...prev,
    [index]: !prev[index],
  }));
};



       const handleModalToggle_WorkChecklist = () => {
        setModalType("Work_Checklist");  // Set the modal type to "Add"
        setOpen(true);
    };

    const handleModalToggle_WorkApproval = () => {
        setModalType("Work_Approval");  // Set the modal type to "Add"
        setOpen(true);
    };


    const [showDetails, setShowDetails] = useState(false);

    const handleIconClick = () => {
        setShowDetails(!showDetails);
    };

 
    return (
    <>
        {/* Header + Breadcrumbs */}
        <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
            <div className='mb-0'>
                <div className="mb-0 px-0">
                    <h4 className='breadcrumb-header'>Manage Work Assignment</h4>
                </div>
                <ol className="breadcrumb fs-7">
                    <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                    <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                    <li className="breadcrumb-item active">Production Management</li>
                </ol>
            </div>

            <div className='d-flex align-items-center gap-3'>
                <Button className="btn btn-primary btn-sm" onClick={() => setFilterOpen(true)}>
                    <i className="fa-solid fa-filter me-2 fs-8"></i> Filter
                </Button>
           
 <Dropdown>
            <Dropdown.Toggle as="button" variant="primary" className="btn btn-primary text-white btn-sm" id="tp-btn">
                <i className="fa-solid fa-circle-down me-2 fs-8"></i> Export
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item as="button" onClick={() => handleExport("csv")} className='d-flex align-items-center px-2'>
                    <img src={csv_ico} alt="CSV" className='w-30px h-30px' />
                    <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                </Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => handleExport("excel")} className='d-flex align-items-center px-2'>
                    <img src={excel_ico} alt="Excel" className='w-30px h-30px' />
                    <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                </Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => handleExport("print")} className='d-flex align-items-center px-2'>
                    <img src={print_ico} alt="Print" className='w-30px h-30px' />
                    <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>

            </div>

            {/* Modal Switch */}
            {open && modalType === "Edit" && <Edit show={open} onClose={() => setOpen(false)} />}
            {open && modalType === "Verify_Checklist" && (
            <Verify_Checklist
                show={open}
                onClose={() => setOpen(false)}
                data={selectedAssignment} onSuccess={() => { 
                        fetchWork();
                        }} 
            />
            )}


                            {open && modalType === "EditQuality" && (
                                        <EditItem
                                            show={open}
                                            onClose={() => setOpen(false)}
                                            data={selectedAssignment}
                                       onSuccess={() => { 
                        fetchWork();
                        }}  />
                                        )}

                              {open && modalType === "WorkChecklist" && (
                                        <WorkChecklist
                                            show={open}
                                            onClose={() => setOpen(false)}
                                            data={selectedAssignment}
                                       onSuccess={() => { 
                        fetchWork();
                        }}  />
                                        )}
            
                            {open && modalType === "ViewQuality" && (
                                        <ViewItem
                                            show={open}
                                            onClose={() => setOpen(false)}
                                            data={selectedAssignment}
                                        />
                                        )}
                            
            
         
            
                    {modalType === "AddWastage" && open && selectedAssignment && (
                <AddWastage
                    show={true}
                    onClose={() => setOpen(false)}
                    assignment={selectedAssignment}
                onSuccess={() => { 
                        fetchWork();
                        }} />
            )}
            
            
            
                            {open && modalType === "Rework" && (
                                <Rework show={open} onClose={() => setOpen(false)} />
                            )}

 
        </div>
 
        <div className='d-flex justify-content-end'>
            <label className='fs-6 text-danger font-w600'>
                {new Date().toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                })}
            </label>
        </div> 
        <div className="table-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
                {/* Per Page Dropdown */}
                <div>
                    <label className="me-2">Show</label>
                    <select className="form-select d-inline w-auto"
                        style={{ fontSize: '0.85rem', height: '30px' }}
                        value={perPage}
                        onChange={(e) => {
                            setPerPage(Number(e.target.value));
                            setPage(1);
                        }}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>

                {/* Search Box */}
                <div>
                    <input
                        type="text"
                        style={{ fontSize: '0.85rem', height: '40px' }}
                        placeholder="Search..."
                        className="form-control"
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setPage(1);
                        }}
                    />
                </div>
            </div>
 
       

            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>Item</th>
                            <th className='min-w-50px'>Qty / Units /
                                <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Production Time</span></Tooltip>} >
                                    <span>Prdt Time</span>
                                </OverlayTrigger>
                            </th>
                            <th className='min-w-80px text-center'>Staff / Work Score</th>
                            <th className='min-w-80px text-center'>Work Status</th>
                            <th className='min-w-50px text-center'>Quality Score</th>
                            <th className='min-w-80px text-center'>Qulaity Status</th>
                            <th className='min-w-80px'>Packing</th>
                            <th className='min-w-80px text-end'>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {assignments.length > 0 ? assignments.map((item, index) => (
                            <React.Fragment key={index}>
                                <tr style={isVisible[index] ? { backgroundColor: 'rgb(255 240 240)' } : {}}>
                                <td>
                                    <div className='d-flex align-items-center justify-content-start gap-2'>
                                        <Button variant="primary tp-btn-light border px-2 pt-1 pb-0 me-1"onClick={() => toggleDiv(index)}
    >
                                            {isVisible[index] ? (
                                                <span><i className="fa-solid fa-angle-down fs-4"></i></span>
                                            ) : (
                                                <span><i className="fa-solid fa-angle-right px-1 py-1 fs-4"></i></span>
                                            )}
                                        </Button>
                                        <LightGallery
                                            onInit={onInit}
                                            speed={500}
                                            plugins={[lgThumbnail, lgZoom]}
                                        >
                                            <div data-src={item.item_info?.image || bgimage} className='border rounded px-1 py-0'>
                                                <img src={item.item_info?.image || bgimage} alt={item.item_info?.name} className='cursor-pointer w-50px h-50px' />
                                            </div>
                                        </LightGallery>
                                        <div className='d-flex flex-column align-items-start'>
                                            <label className='text-black font-w400 fs-7'  title={item.item_info?.name.length > 15 ? item.item_info?.name : ''}>{item.item_info?.name.length > 15
                                                ? item.item_info?.name.slice(0, 15) + '...'
                                                : item.item_info?.name}</label>
                                            <label className='text-black font-w400 fs-7'>{item.item_info?.category}</label>
                                            <label className="fs-8 font-w500 text-dark">{item.item_info?.sub_category} </label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className='d-flex flex-column gap-1'>
                                        <label className='text-black font-w400 fs-7'>
                                     
                                 {item.product_info?.length > 0 ? (() => {
                                            // Create a map to hold totals per unit
                                            const totals = {};

                                            item.product_info.forEach(prod => {
                                                // cooking_quantity is like "1.5 kgs", "500 gms", or "2 litres"
                                                const match = prod.cooking_quantity.match(/^([\d.]+)\s*(\w+)?$/);
                                                if (match) {
                                                const quantity = parseFloat(match[1]) || 0;
                                                const unit = match[2] || 'unit';

                                                if (!totals[unit]) {
                                                    totals[unit] = 0;
                                                }
                                                totals[unit] += quantity;
                                                }
                                            });

                                            // Format the totals back to strings like "2.5 kgs"
                                            const result = Object.entries(totals)
                                                .map(([unit, qty]) => `${qty % 1 === 0 ? qty : qty.toFixed(2)} ${unit}`)
                                                .join(', ');

                                            return result;
                                            })() : (

                                    <label className='text-muted'>-</label>
                                )}</label>
                                        <label className='text-danger fs-7 font-w400'>02h 30m 00s</label>
                                    </div>
                                </td>
                                <td>
                                    <div className='d-flex flex-row gap-2 align-items-center justify-content-center'>
                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Staff Count</span></Tooltip>} >
                                            <Badge bg="primary" className='py-1 px-2 fs-8'>{item.stagging_with_staff?.length ?? 0}</Badge>
                                        </OverlayTrigger>
                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Work Score</span></Tooltip>} >
                                            <Badge bg="secondary" className='py-1 px-2 fs-8'>{item.stagging_with_staff?.reduce((total, staff) => total + (staff.staff_score ?? 0), 0)}</Badge>
                                        </OverlayTrigger>
                                    </div>
                                </td>
                                <td className='text-center'>
                                {(() => {
                                    const rawStatus = item.workassignment_status;
                                    const isMultiple = typeof rawStatus === 'string' && rawStatus.includes(',');

                                    // Case: Multiple statuses → Always show badges
                                    if (isMultiple) {
                                    return rawStatus.split(',').map((status) => {
                                        const parsedStatus = parseInt(status);
                                        const isRejected = parsedStatus === 6;

                                        return (
                                        <Badge
                                            key={status}
                                            bg={isRejected ? 'light' : getBadgeVariant(parsedStatus)}
                                            style={{
                                            color: isRejected ? 'red' : 'white',
                                            border: isRejected ? '2px dashed red' : undefined,
                                            marginRight: '6px',
                                            padding: '4px 8px',
                                            fontSize: '0.75rem',
                                            }}
                                        >
                                            {getStatusLabel(parsedStatus)}
                                        </Badge>
                                        );
                                    });
                                    }

                                    // Case: Single status = 2 → Show Dropdown (Switch)
                                    const parsedStatus = parseInt(rawStatus);
                                    if (parsedStatus === 2) {
                                    return (
                                        <Dropdown>
                                        <Dropdown.Toggle as="a" className="cursor-pointer py-2">
                                            <Badge
                                            bg={getBadgeVariant(parsedStatus)}
                                            style={{
                                                color: 'white',
                                                padding: '4px 8px',
                                                fontSize: '0.75rem',
                                            }}
                                            >
                                            {getStatusLabel(parsedStatus)}
                                            </Badge>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {getNextStatusOptions(parsedStatus).map((status) => (
                                            <Dropdown.Item
                                                key={status}
                                                onClick={() => handleStatusChange(item.sno, status, item.item_info?.name)}
                                            >
                                                {getStatusLabel(status)}
                                            </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                        </Dropdown>
                                    );
                                    }

                                    // All other single statuses → Show normal badge
                                    const isRejected = parsedStatus === 6;
                                    return (
                                    <Badge
                                        bg={isRejected ? 'light' : getBadgeVariant(parsedStatus)}
                                        style={{
                                        color: isRejected ? 'red' : 'white',
                                        border: isRejected ? '2px dashed red' : undefined,
                                        padding: '4px 8px',
                                        fontSize: '0.75rem',
                                        }}
                                    >
                                        {getStatusLabel(parsedStatus)}
                                    </Badge>
                                    );
                                })()}
                                </td>
                                <td className='text-center'>
                                    <label className='text-black font-w600 fs-7 rounded-circle py-1 px-2' style={{backgroundColor: '#ff8893'}}> {
                                    item.checklist_score != null && item.checklist_score !== ''
                                    ? (
                                    <> 
                                        {String(Number(item.checklist_score)).padStart(2, '0')} 
                                    </>
                                    ) : (
                                    <>00</>
                                    )
                                }</label>
                                </td>
                                <td className='text-center'>
                                    {String(item.workassignment_status) === "5" ? (
                                        <Badge bg="success" className='text-white font-w400 fs-7 py-1 px-2 rounded'>Completed</Badge>
                                    ) : String(item.workassignment_status).includes("4") || String(item.workassignment_status).includes("6") ? (
                                        <Badge className='text-white font-w400 fs-7 py-1 px-2 rounded' style={{backgroundColor: '#ff8507'}}>Pending</Badge>
                                    ) : (
                                        <>-</>
                                    )}
                                 
                                
                                </td>
                                <td className='text-center'>
                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                        <input 
                                            className="form-check-input me-2" 
                                            type="checkbox" 
                                            role="switch"
                                            checked={String(item.workassignment_status) === "5"}
                                            disabled={String(item.workassignment_status) !== "5"}
                                        />
                                    </div>
                                </td>
                              
                                <td className="text-center">
                                    <Dropdown drop="left">
                                        <Dropdown.Toggle as="a" className="i-false cursor-pointer">
                                        <Button variant="primary tp-btn-light px-3 py-2">
                                            <span><i className="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                        </Button>
                                        </Dropdown.Toggle>
        
                                        <Dropdown.Menu>
        
                                        {/* View - Always Visible */}
                                        <Dropdown.Item className="px-2 py-1">
                                            <div className="d-flex align-items-center" onClickCapture={() => handleModalToggle_View(item)}>
                                            <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                <span><i className="fa-solid fa-eye fs-5 text-danger"></i></span>
                                            </div>
                                            <div className="ms-2 fs-7">View</div>
                                            </div>
                                        </Dropdown.Item>
        
                                        <Dropdown.Item className="px-2 py-1">
                                            <div className="d-flex align-items-center" onClickCapture={() => handleModalToggle_Work(item)}>
                                            <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                <span><i class="fa-solid fa-clipboard-check fs-5 text-danger"></i></span>
                                            </div>
                                            <div className="ms-2 fs-7">Work Checklist</div>
                                            </div>
                                        </Dropdown.Item>
        
        
                                        {/* Quality Checklist - Shown only when status is NOT 0,1,2 */}
                                        {!['0', '1', '2'].includes(String(item.workassignment_status)) && (
                                            <Dropdown.Item className="px-2 py-1" onClickCapture={() => handleModalToggle_Edit(item)}>
                                            <div className="d-flex align-items-center">
                                                <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                <span><i class="fa-solid fa-thumbs-up fs-5 text-danger"></i></span>
                                                </div>
                                                <div className="ms-2 fs-7">Quality Approval</div>
                                            </div>
                                            </Dropdown.Item>
                                        )}
        
                                        {/* Add Wastage - Shown only when status is 5 */}
                                        {parseInt(item.workassignment_status) === 5 && (
                                            <Dropdown.Item className="px-2 py-1" onClick={() => handleModalToggle_AddWastage(item)}>
                                            <div className="d-flex align-items-center">
                                                <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                <span><i className="fa-solid fa-trash-restore fs-5 text-danger"></i></span>
                                                </div>
                                                <div className="ms-2 fs-7">Add Wastage</div>
                                            </div>
                                            </Dropdown.Item>
                                        )}
        
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td>
                                </tr>
                                {isVisible[index] && (
                                    <tr style={{ backgroundColor: '#ffffff' }}>
                                        <td colSpan={8}>
                                            <table className="table align-top table-striped table-hover fs-7 gy-1 gs-2">
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-100px'>Staff Name</th>
                                                        <th className='min-w-50px'>Job Position</th>
                                                        <th className='min-w-80px'>Work Score</th>
                                                        <th className='min-w-50px'>Staff Work Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {item.stagging_with_staff?.map((staff, idx) => (
                                                        <tr key={staff.id ?? idx}>
                                                            <td>
                                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                                    <LightGallery
                                                                        onInit={onInit}
                                                                        speed={500}
                                                                        plugins={[lgThumbnail, lgZoom]}
                                                                    >
                                                                        <div data-src={staff1} className='border rounded px-1 py-0'>
                                                                            <img src={staff1} alt={staff.staff_name} className='cursor-pointer w-50px h-50px' />
                                                                        </div>
                                                                    </LightGallery>
                                                                    <div className='d-flex flex-column align-items-start'>
                                                                        <label className='text-black font-w400 fs-7'>{staff.staff_name}</label>
                                                                        <label className='text-dark font-w400 fs-7'>---</label> {/* Replace if you have last name or designation */}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>---{/* Replace with staff role if available */}</label>
                                                            </td>
                                                            <td>
                                                                <OverlayTrigger
                                                                    trigger="hover"
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className='toltip-popover'>
                                                                            <span className='fs-8 text-white fw-semibold'>Work Score</span>
                                                                        </Tooltip>
                                                                    }>
                                                                    <Badge bg="danger" className='py-1 px-2 fs-8'>
                                                                        {(staff.staff_score ?? 0).toString().padStart(2, '0')}
                                                                    </Badge>
                                                                </OverlayTrigger>
                                                            </td>
                                                            <td>
                                                                {(staff.staff_status ?? 0) === 0 ? (
                                                                <label className='text-white font-w400 fs-7 py-1 px-2 rounded' style={{ backgroundColor: '#24a52e' }}>
                                                                    Work Done
                                                                </label>
                                                                ) : (
                                                                <label className='text-white font-w400 fs-7 py-1 px-2 rounded' style={{ backgroundColor: '#5f9ea0' }}>
                                                                    Work not Started
                                                                </label>
                                                                )}

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    )}
                            </React.Fragment>
                            )) : (
                                <tr><td colSpan="7" className="text-center text-muted py-4">No Data Found</td></tr>
                            )} 
                    </tbody>
                </table>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center mt-3">
                <div>
                    {assignments.length > 0 ? (
                        <span className="text-muted">
                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + assignments.length} of {TotalCount} entries
                        </span>
                    ) : (
                        <span className="text-muted">Showing 0 to 0 of 0 entries</span>
                    )}
                </div>
                <nav>
                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => setPage(page - 1)}>Previous</button>
                        </li>
                        {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                        ))}
                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
 
<Drawer
            anchor="right"
            open={filterOpen}
            onClose={() => setFilterOpen(false)}
            disableEscapeKeyDown
            BackdropProps={{
                onClick: (e) => e.stopPropagation(),
            }}
            sx={{
                width: 400,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: 400,
                    boxSizing: 'border-box',
                },
                '@media (max-width: 375px)': {
                    '& .MuiDrawer-paper': {
                        width: 320,
                    },
                },
                '@media (max-width: 320px)': {
                    '& .MuiDrawer-paper': {
                        width: 280,
                    },
                },
            }}
        >
            <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                <h5 className='fs-4' style={{ color: '#ea1d25' }}>Manage Work Assignment Filter</h5>
                <div>
                    <Button variant="" type="button" size='sm' onClick={() => setFilterOpen(false)}>
                        <span className='fs-2'>×</span>
                    </Button>
                </div>
            </div>

            <div className='card border-0'>
                <div className='card-body py-0'>
                    <div className='row mb-2 py-2'>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date</label>
                            <Select
                                value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                onChange={(selectedOption) => {
                                    const selectedValue = selectedOption.value;
                                    setDateFilSeltValue(selectedValue);

                                    if (selectedValue === "this_week") {
                                        setWeekSTDTFilValue(moment().startOf('isoWeek').toDate());
                                        setWeekEDDTFilValue(moment().endOf('isoWeek').toDate());
                                    }

                                    if (selectedValue === "today") {
                                        setTodayFilValue(new Date());
                                    }

                                    if (selectedValue === "this_month") {
                                        setMonthFilValue(new Date());
                                    }

                                    if (selectedValue === "custom") {
                                        const now = new Date();
                                        setCustomSTDTFilValue(now);
                                        setCustomEDDTFilValue(now);
                                    }
                                }}
                                options={date_fil_options}
                                menuPlacement="top"
                            />
                        </div>

                     

                        {["today", "date"].includes(date_fil_selt_value) && (
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date</label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'>
                                    <i className='fa-solid fa-calendar-days fs-4'></i>
                                </div>
                                <DatePicker
                                    value={today_fil_value}
                                    onChange={setTodayFilValue}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                        </div>
                    )}


                        {date_fil_selt_value === "this_week" && (
                            <>
                                <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">Start Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={week_stdt_fil_value}
                                            onChange={setWeekSTDTFilValue}
                                            format="DD-MM-YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">End Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={week_eddt_fil_value}
                                            onChange={setWeekEDDTFilValue}
                                            format="DD-MM-YYYY"
                                            calendarPosition="top-end"
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        {date_fil_selt_value === "this_month" && (
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">This Month</label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'>
                                        <i className='fa-solid fa-calendar-days fs-4'></i>
                                    </div>
                                    <DatePicker
                                        value={month_fil_value}
                                        onChange={setMonthFilValue}
                                        format="MMM-YYYY"
                                        calendarPosition="top"
                                        mode="single"
                                        onlyMonthPicker
                                    />
                                </div>
                            </div>
                        )}

                        {date_fil_selt_value === "custom" && (
                            <>
                                <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">Start Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={custom_stdt_fil_value}
                                            onChange={setCustomSTDTFilValue}
                                            format="DD-MM-YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-2">
                                    <label className="text-black font-w500 fs-7">End Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'>
                                            <i className='fa-solid fa-calendar-days fs-4'></i>
                                        </div>
                                        <DatePicker
                                            value={custom_eddt_fil_value}
                                            onChange={setCustomEDDTFilValue}
                                            format="DD-MM-YYYY"
                                            calendarPosition="top-end"
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-center gap-1 pb-3">
                    <Button className="me-2 btn-sm" variant="secondary" onClick={handleResetFilter}>
                        <span className='font-w400'>Reset</span>
                    </Button>
                    <Button className="me-2 btn-sm" variant="primary" onClick={handleGoFilter}>
                        <span className='font-w400'>Go</span>
                    </Button>
                </div>
            </div>
        </Drawer>

    </>
); 

};

export default Works;
